<template>
  <div>
    <b-input-group>
      <b-form-input
        size="sm"
        :disabled="this.$props.isDisabled"
        v-model="query"
        placeholder="Исполнитель"
        autocomplete="off"
        @focus="onFocusIn"
        @blur="onFocusOut"/>

      <b-input-group-append>
        <b-button size="sm" :disabled="!query || this.$props.isDisabled" @click="onClear">
          <font-awesome-icon icon="times-circle"/>
        </b-button>
      </b-input-group-append>

      <b-list-group class="autocomplete-input-worker" v-if="isFocus">
        <b-list-group-item
          v-for="(item, index) in items"
          :key="index"
          @mousedown="onClick(item)"
          button
          class="text-small"
        >
          <p class="m-0 p-0">{{item.name}}</p>
          <p class="m-0 p-0 text-secondary">{{item.phone}}</p>
        </b-list-group-item>
        <b-list-group-item v-if="items.length === 0" disabled>
          <small>Ничего не найдено</small>
        </b-list-group-item>
      </b-list-group>
    </b-input-group>
  </div>
</template>

<script>
import workers from "../../network/workers";

export default {
  name: "WorkerSelect",
  mixins: [ workers ],
  props: {
    isDisabled: Boolean,
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      location_id: 0,
    }
  },
  methods: {
    async configure(id, locationId) {
      if (locationId != null) {
        this.location_id = locationId;
      }

      if (id > 0) {
        const user = (await this.getWorkerById(id)).data;
        if (user != null) {
          this.query = user.name;
          return;
        }
      }

      this.query = "";
      this.items = await this.getItems();
    },
    onFocusIn() {
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;
    },
    onClear() {
      this.query = "";
      this.$emit('onSelect', 0);
    },
    onClick(item) {
      this.query = item.name;
      this.$emit('onSelect', item.id);
    },
    async getItems() {
      const data = {
        page: 1,
        size: 400,
        query: this.query.toLowerCase(),
        locationId: this.location_id
      }

      const result = await this.getWorkersSearch(data);
      return result.data != null ? result.data : [];
    }
  },
  watch: {
    'query': {
      handler: async function () {
        if (this.query != null) {
          this.items = await this.getItems();
        }
      }, deep: true, immediate: true
    },
  }
}
</script>

<style>
.autocomplete-input-worker {
  max-height: 250px;
  margin-top: 31px;
  min-width: 100%;
  overflow-y: auto;
  position: absolute;
  z-index: 1000;
}

.autocomplete-input-worker .list-group-item {
  padding: 0.5rem 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Workers/WorkerSelect.vue